// Action Types
export const EDIT_MEMBER = 'EDIT_MEMBER';
export const CANCEL_EDIT_MEMBER = 'CANCEL_EDIT_MEMBER';
export const SAVING_MEMBER_FULL = 'SAVING_MEMBER_FULL';
export const SAVE_MEMBER_FULL = 'SAVE_MEMBER_FULL';
export const SAVE_MEMBER_FULL_SUCCESS = 'SAVE_MEMBER_FULL_SUCCESS';
export const SAVE_MEMBER_FULL_ERROR = 'SAVE_MEMBER_FULL_ERROR';
export const FINISH_EDIT_MEMBER = 'FINISH_EDIT_MEMBER';
